module.exports = __webpack_public_path__ + "static/media/conce_background.cd495056.png";